import {Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {QueryParamsHandling} from '@angular/router';
import {Spinner} from '@npck/libs/commons';
import {BreadcrumbsComponent, ButtonColor, ButtonType} from '@npck/libs/ui-kit';
import {isArray, isString} from 'lodash-es';
import {Observable} from 'rxjs';
import {Path} from '../../path';

@Component({
    selector: 'af-main-container',
    templateUrl: 'main-container.component.html',
    styleUrls: ['main-container.component.scss'],
    standalone: false
})
export class MainContainerComponent {
    @Output() buttonClickListener = new EventEmitter<void>();
    @Input() showBackButton = true;
    @Input() enableScroll = true;
    @Input() showBreadcrumbs = true;
    @Input() queryParamsHandling: QueryParamsHandling;
    @Input() filterOneLevelNavigation = false;
    @Input() filterNavigationPath: string;
    @Input() customLastBreadcrumb: string;
    @Input() rootPath: string;
    @Input() title: string;
    @Input() buttonLabel: string;
    @Input() buttonType: ButtonType = 'primary';
    @Input() buttonColor: ButtonColor;
    @Input() buttonDisabled = false;
    @Input() buttonDisabledTooltip: string;
    @Input() isInDevelopment: boolean = false;
    @Input() spinnerIds: string | string[];
    @Input() buttonSpinnerId: string;
    @Input() tabPathToTab: Record<string, string>;
    @Input() specialFilter: (path: string) => boolean;
    @Input() navigateBackListener: () => Observable<boolean>;
    @Input() customNavigateToPath: (path?: string) => boolean | void;
    @Input() breadcrumbCustomizer: (path: string) => string;
    @ViewChild('breadcrumbs') breadcrumbs: BreadcrumbsComponent;
    Spinner = Spinner;

    prefixPaths: string[] = [
        Path.ADMIN_PANEL,
        Path.ANALYTICS,
    ];

    get spinnerIsShown(): boolean {
        if (isString(this.spinnerIds)) {
            return Spinner.isShown(this.spinnerIds);
        } else if (isArray(this.spinnerIds)) {
            return Spinner.isShown(...this.spinnerIds);
        }
        return false;
    }
}
